import { useContext, useEffect, useState } from 'react';
import { PublicConfigContext } from '../contexts/publicConfigContextInstance';
import { api } from '../services/authenticatedApi';

export function CupidNavButton() {
  const cupidUrl = useContext(PublicConfigContext)?.cupidUrl;
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!cupidUrl) {
      setEnabled(false);
      return;
    }

    let active = true;
    api
      .get('/auth/cupid')
      .then(() => {
        if (active) setEnabled(true);
      })
      .catch(() => {
        if (active) setEnabled(false);
      });

    return () => {
      active = false;
    };
  }, [cupidUrl]);

  if (!enabled || !cupidUrl) return null;

  return (
    <a
      href={cupidUrl}
      className="px-3 py-1.5 text-sm font-medium rounded-lg bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 hover:bg-purple-100 dark:hover:bg-purple-900/50 transition-colors"
    >
      CUPID
    </a>
  );
}
